export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20lifestyle%20flat%20lay%20featuring%20sneakers%20hoodie%20bag%20sunglasses%20and%20accessories%20artistically%20arranged%20on%20warm%20terracotta%20toned%20surface%2C%20editorial%20product%20photography%2C%20rich%20textures%20and%20shadows%2C%20soft%20directional%20daylight%2C%20luxury%20minimal%20composition%20with%20negative%20space%2C%20no%20text&width=1800&height=900&seq=hero-main-v3&orientation=landscape"
          alt="CSSBuy Spreadsheet - Produtos e Categorias"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-500">
            <i className="ri-sparkling-line text-background-50 text-xs"></i>
          </div>
          <span className="text-background-50/90 text-sm font-medium">
            Guia CSSBuy 2026
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-5 leading-tight max-w-3xl mx-auto">
          Melhor CSSBuy Spreadsheet 2026
        </h1>

        <p className="text-background-50/80 text-base md:text-lg max-w-xl mx-auto mb-8 leading-relaxed">
          Sua fonte completa para planilhas CSSBuy, guias de compra e comparações. Economize tempo e dinheiro nas suas compras da China.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-base cursor-pointer hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            Acessar Site Principal
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
          <a
            href="#categorias"
            className="flex items-center gap-2 px-7 py-3 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-base cursor-pointer hover:bg-background-50/10 transition-all whitespace-nowrap"
          >
            Explorar Categorias
            <i className="ri-arrow-down-line text-lg"></i>
          </a>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm">
          <i className="ri-arrow-down-s-line text-background-50 text-lg"></i>
        </div>
      </div>
    </section>
  );
}